import React from "react";
import HomeHeader from "../components/HomeHeader";
import MobNavbar from "../components/MobNavbar";
import styles from "../styles/Main.module.css";
import SectionDisplay from "../components/Main/SectionDisplay";
import FlipNumbers from "react-flip-numbers";
import CoinsGrid from "../components/Main/CoinsGrid";
import SplineGraph from "../components/Main/SplineGraph";
import { Pacman } from "../assets/Svg";

import ContractsGrid from "../components/Main/ContractsGrid";
import { useQuery } from "@tanstack/react-query";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router";

export default function Main() {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["/dashboard/home"],
  });

  console.log(data);

  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

  return (
    <>
      <HomeHeader />
      <MobNavbar />
      <div className={styles.wrapper}>
        <div className={styles.main}>
          <SectionDisplay
            onClick={() => navigate("/search-token-sniffer")}
            title="honeypot checker"
            subtitle="honeypot checker"
          />
          <SectionDisplay
            onClick={() => navigate("/search-analysis")}
            title="deployer and holders"
            subtitle="data"
          />
          <SectionDisplay
            onClick={() => {
              navigate("/choose");
            }}
            title="social analytics"
            subtitle="cointrendz+TX pepeai holders"
          />
          <div className={styles.sectionDisplay}>
            <div className={styles.sectionDisplayInset}>
              <div className={styles.sectionDisplayContentGasPrice}>
                <div>
                  <FlipNumbers
                    width={30}
                    height={56}
                    play
                    color="#fff"
                    background-image={`linear-gradient(180deg, transparent 0%, #0e0d0d 100%)`}
                    numberStyle={{
                      fontSize: 16,
                    }}
                    delay={2}
                    duration={1.5}
                    numberClassName={styles.flipNumbers}
                    nonNumberClassName={styles.flipNonNumbers}
                    numbers={
                      data?.currentGas
                        ? Math.floor(data.currentGas).toString()
                        : "0"
                    }
                  />
                </div>
                <div className={styles.sectionDisplayGasPrice}>
                  <div className={styles.sectionDisplayTitle}>gwei</div>
                  <div className={styles.sectionDisplaySubtitle}>
                    Current gas Price
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.imgContainer}>
          <div className={styles.text}>Will it be the one today?</div>
          <div className={styles.center}>
            <img
              className={styles.coinLeft}
              src={require("../assets/images/coinLeft.png")}
              alt="coin"
            />
            <img
              className={styles.coinRight}
              src={require("../assets/images/coinRight.png")}
              alt="coin"
            />
            <div className={styles.coinsToday}>
              <FlipNumbers
                width={isMobile ? 20 : 80}
                height={isMobile ? 36 : 136}
                play
                color="#fff"
                background-image={`linear-gradient(180deg, transparent 0%, #0e0d0d 100%)`}
                numberStyle={{
                  fontSize: isMobile ? 16 : 38,
                }}
                delay={1.5}
                duration={1.5}
                numberClassName={styles.flipNumbers}
                nonNumberClassName={styles.flipNonNumbers}
                numbers={data?.newCoinsCount.toString() || "0"}
              />

              <div className={styles.coinsTodayText}>new coins today</div>
            </div>
          </div>
        </div>
        <CoinsGrid />
        <div className={styles.sectionHeader}>
          Your Income and expenses <Pacman />
        </div>
        <SplineGraph />
        <div className={styles.center}>
          <div className={`${styles.coinsToday} ${styles.contractsDeployed}`}>
            <FlipNumbers
              width={isMobile ? 20 : 80}
              height={isMobile ? 36 : 136}
              play
              color="#fff"
              background-image={`linear-gradient(180deg, transparent 0%, #0e0d0d 100%)`}
              numberStyle={{
                fontSize: isMobile ? 16 : 38,
              }}
              delay={2}
              duration={1.5}
              numberClassName={styles.flipNumbers}
              nonNumberClassName={styles.flipNonNumbers}
              numbers={data ? data.contractsDeployedCount.toString() : `0`}
            />

            <div className={styles.coinsTodayText}>
              Contracts deployed on uniswap in the last 60 mins
            </div>
          </div>
        </div>
        <ContractsGrid />
        <div className={styles.copy}>
          Copyright 2023 pepe analytics. all rights reserved.
        </div>
      </div>
    </>
  );
}
